export default __webpack_public_path__ + "9535cc0c46c262c36d19ff8aa72405c1.png";